import React from 'react';
import Footer from '../common/Footer';
import fback from '../../images/fbackground.png';
import BannerSection from './BannerSection';
import WorkingSection from './WorkingSection';
import Service from './Service';
import Project from './Project';
import ScrollToTopButton from '../common/ScrollToTopButton';
import WhatsAppPopup from 'components/common/WhatsAppPopup';
import Gallery from './Gallery';
import Recommendations from './Recommendations';
import StatsSection from './StatsSection';
import Testimonial from './Testimonial';
import Connect from './Connect';

const Home = () => {
    return (
        <>
            <BannerSection />

            {/* working section */}
            <section className="relative justify-center max-w-[1200px] mx-auto w-full h-[450px] sm:h-[600px] md:h-[720px]  lg:h-[680px] bg-cover bg-center">
                <WorkingSection />
            </section>

            <Project />
            <Service />
            <Gallery />
            <Connect />
            <StatsSection />
            <Testimonial />
            <Recommendations />
            <WhatsAppPopup />
            <ScrollToTopButton />

            {/* footer */}
            <section
                className="relative justify-center w-full h-[340px] sm:h-[600px] md:h-[550px] lg:h-[460px] bg-cover bg-center"
                style={{ backgroundImage: `url(${fback})` }}
            >
                <Footer />
            </section>
        </>
    );
};

export default Home;
